<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Equipamentos</h5>
        <b-button size="sm" to="/ativos/equipamentos/add"
          ><i class="fe fe-plus"></i
        ></b-button>
      </div>
    </div>

    <lista-equipamentos class="mb-4" />

    <!-- <b-modal ref="adicionar" hide-footer title="Adicionar novo equipamento" size="xl">
      <template v-slot:default="{ hide }">
        <formulario-equipamentos @hide="hide" :dispositivo="null" />
      </template>
    </b-modal> -->
  </div>
</template>
<script>
import ListaEquipamentos from "./lista";

export default {
  components: {
    ListaEquipamentos
  },
  data: function() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>